import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "mFZUiJ",
    defaultMessage: "Cart {name}",
    description: "cart visibility detail page title",
  },
  anonymous: {
    id: "sbZv0P",
    defaultMessage: "Anonymous cart",
    description: "cart with no customer email",
  },
  cartDetails: {
    id: "yqjqhF",
    defaultMessage: "Cart Details",
    description: "cart visibility detail section header",
  },
  subtotal: {
    id: "r+5fRT",
    defaultMessage: "Subtotal",
    description: "cart visibility detail summary label",
  },
  product: {
    id: "B3jim3",
    defaultMessage: "Product",
    description: "cart visibility detail column",
  },
  sku: {
    id: "ejWzWU",
    defaultMessage: "SKU",
    description: "cart visibility detail column",
  },
  variantName: {
    id: "jOOr1R",
    defaultMessage: "Variant",
    description: "cart visibility detail column",
  },
  quantity: {
    id: "aDXPI9",
    defaultMessage: "Quantity",
    description: "cart visibility detail column",
  },
  unitPrice: {
    id: "vImV4v",
    defaultMessage: "Unit price",
    description: "cart visibility detail column",
  },
  lineTotal: {
    id: "Dd53J+",
    defaultMessage: "Total",
    description: "cart visibility detail column",
  },
  customer: {
    id: "Iqjoba",
    defaultMessage: "Customer",
    description: "cart visibility detail summary label",
  },
  total: {
    id: "HxMPkm",
    defaultMessage: "Estimated total",
    description: "cart visibility detail summary label",
  },
  takeOver: {
    id: "Cenw+a",
    defaultMessage: "Take over",
    description: "promote cart to draft order button",
  },
  openDraft: {
    id: "Jfwcuo",
    defaultMessage: "Open draft #{number}",
    description: "open the linked draft order",
  },
  empty: {
    id: "OP4u/b",
    defaultMessage: "This cart has no lines.",
    description: "cart visibility detail empty state",
  },
  notFound: {
    id: "Q7bP5W",
    defaultMessage: "Cart not found. It may have been purged or promoted.",
    description: "cart visibility detail not found state",
  },
});
